import React from "react";
import DeviceContext from "../../../../services/indentifyDevice";
import LoginPopup from "../../../login/generic/loginPopup";
import NuvamaLogo from "../../../../assets/new_images/nuvama-logo.svg";

import SetPasswordForm, {
  VSetPasswordFormProps,
} from "../Forms/SetPasswordForm";

export interface VSetPasswordScreenProps extends VSetPasswordFormProps {
  onClose?: () => void;
}

const SetPassword: React.FC<VSetPasswordScreenProps> = (props) => {
  return (
    <LoginPopup
      leftHeaderContent={
        !DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      centerHeaderContent={
        DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      onClose={props.onClose}
      className="login_scrn"
    >
      <SetPasswordForm {...props} />
    </LoginPopup>
  );
};

export default SetPassword;
